import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import { getColor } from '@utils/theme';

import Check from '@assets/vectors/checkmark.inline.svg';
import Error from '@assets/vectors/close.inline.svg';

import theme from '@theme/FolxTheme';

interface IValidationRuleProps {
	valid: boolean;
	label: string;
}

const IconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${theme.spacing.sm};
	width: ${theme.spacing.sm};

	svg {
		height: 50%;
		width: auto;
	}
`;

const StyledValidationRule = styled.div`
	display: flex;
	align-items: center;
`;

const StyledText = styled(BasicText)<{ valid: boolean }>`
	color: ${({ valid }) =>
		valid
			? theme.tints.darken40(theme.colors.placeholderGray)
			: theme.tints.darken40(theme.colors.red)};
`;

const Bullet = styled(BasicText)`
	color: ${theme.tints.darken40(theme.colors.placeholderGray)};
`;

const ValidationRule: FC<IValidationRuleProps> = ({ valid, label }) => {
	return (
		<StyledValidationRule>
			<IconContainer>
				{valid ? (
					<Bullet variant="fineprint">&#11049;</Bullet>
				) : (
					<Error fill={getColor('red', 'darken40')} />
				)}
			</IconContainer>
			<StyledText valid={valid}> {label} </StyledText>
		</StyledValidationRule>
	);
};

export default ValidationRule;
